import type { TFunction } from "i18next";
import { getRouteProjectDetails } from "@/zapi-frontend/shared/const/router";
import { TNotification } from "./store";

export function getNotificationContent(t: TFunction, notification: TNotification) {
  const project = notification.project?.name;
  switch (notification.type) {
    case "chat_responded":
      return {
        title: project ? t("notifications.chatResponded", { project }) : t("notifications.chatRespondedGeneric"),
        subtitle: undefined
      };
    case "project_ready":
      return {
        title: project ? t("notifications.analysisReady", { project }) : t("notifications.analysisReadyGeneric"),
        subtitle: t("notifications.analysisReadySubtitle")
      };
  }
}

export function getNotificationTarget(notification: TNotification) {
  const projectId = notification.projectId ?? notification.project?.id;
  if (!projectId) return null;
  return notification.type === "project_ready"
    ? `${getRouteProjectDetails(projectId)}?tab=overview`
    : getRouteProjectDetails(projectId);
}
